module.exports = __webpack_public_path__ + "static/media/scf.cc2cba3b.png";